import { getRelativeBasePath } from '../environments/path'
import { addToUrl, encodeForURL } from '../formatters/string-formatter'
import { isLoggedIn } from './authentication-manager'

export const markAsSecurePage = function () {
  if (!isLoggedIn()) {
    setSecurePageRedirect(window.location.pathname + window.location.search)
    window.location.href = '/login'
  }
}

export const setSecurePageRedirect = function (securePageRedirect) {
  window.localStorage.setItem('securePageRedirect', securePageRedirect)
}

export const getSecurePageRedirect = function () {
  return window.localStorage.getItem('securePageRedirect')
}

export const goToSecurePageRedirect = function () {
  const url = window.localStorage.getItem('securePageRedirect')
  if (url) {
    window.localStorage.removeItem('securePageRedirect')
    const sanitizedUrl = encodeForURL(url)
    // Guard: only allow same-origin relative paths (starts with '/' but not '//')
    if (/^\/(?!\/)/.test(sanitizedUrl)) {
      window.location.href = sanitizedUrl
    } else {
      window.location.href = getRelativeBasePath() + '/'
    }
  } else {
    window.location.href = getRelativeBasePath() + '/'
  }
}

// export const setRegistrationPageRedirect = function (registrationPageRedirect) {
//   // just redirect to the path because we dont want to redirect to external urls for security reasons
//   try {
//     var jqueryUrl = $.url(registrationPageRedirect)
//     registrationPageRedirect = jqueryUrl.data.attr.path

//     if (jqueryUrl.data.attr.query) {
//       registrationPageRedirect = registrationPageRedirect.addToUrl(jqueryUrl.data.attr.query)
//     }

//     if (jqueryUrl.data.attr.fragment) {
//       registrationPageRedirect += '#' + jqueryUrl.data.attr.fragment
//     }

//   } catch (error) {
//     registrationPageRedirect = '/'
//   }

//   window.localStorage.setItem('registrationPageRedirect', registrationPageRedirect)
// }

export const getRegistrationPageRedirect = function () {
  return window.localStorage.getItem('registrationPageRedirect')
}

export const goToRegistrationPageRedirect = function () {
  let url = window.localStorage.getItem('registrationPageRedirect')

  if (url) {
    window.localStorage.removeItem('registrationPageRedirect')
    url = addToUrl(url, 'registerSuccess=true')
    window.location.href = url
  } else {
    window.location.href = getRelativeBasePath() + '/?registerSuccess=true'
  }
}
